import * as z from "zod/v4";

export const refreshShopifyPlan = {
  name: "refreshShopifyPlan" as const,
  input: z.void(),
  output: z.void(),
};
